/* ============================================================
   GoBrands - relabel items in the Meteor Mega Menu

   The top navigation is NOT a Shopify menu. The Meteor Mega Menu app
   renders it client-side from its own settings - the word "STOCK" does
   not appear in the server HTML at all - so the labels cannot be changed
   from the Admin API or from theme files.

   THE PROPER FIX IS IN THE APP. This script is a front-end override for
   the cases where editing the app is not convenient. It is deliberately
   conservative:

     - it matches on HREF, never on the existing text, so it keeps working
       if the app's label or letter-case changes
     - it is scoped to `a[class^="Meteor-Navigation__Link"]`, so the
       theme's own links to the same collection are left alone
     - it rewrites the anchor's text node only, leaving any caret or icon
       element the app puts inside
     - a MutationObserver re-applies it, because the app re-renders the
       nav on breakpoint changes and when a dropdown opens

   Labels are UPPERCASE to match the app's other items, which are
   uppercase at source. The desktop links carry an inline
   `text-transform: capitalize`, so a lowercase word here would render
   as "Ready To Deliver" with an odd capital T.

   To relabel another item, add a `path: 'NEW LABEL'` pair below.
   ============================================================ */
(function () {
  if (window.__gbMenuFix) return;
  window.__gbMenuFix = true;

  var LABELS = {
    '/collections/stock': 'READY TO DELIVER'
  };

  var SEL = 'a[class^="Meteor-Navigation__Link"]';

  function pathOf(a) {
    var href = a.getAttribute('href') || '';
    // strip origin and any query/hash so '/collections/stock?x=1' still matches
    return href.replace(/^https?:\/\/[^/]+/, '').split('?')[0].split('#')[0].replace(/\/$/, '');
  }

  function apply() {
    document.querySelectorAll(SEL).forEach(function (a) {
      var want = LABELS[pathOf(a)];
      if (!want) return;

      // find the first non-empty text node and rewrite just that
      var node = null;
      for (var i = 0; i < a.childNodes.length; i++) {
        var n = a.childNodes[i];
        if (n.nodeType === 3 && n.nodeValue.trim() !== '') { node = n; break; }
      }
      if (node) {
        if (node.nodeValue.trim() !== want) node.nodeValue = want;
      } else if (a.textContent.trim() !== want) {
        a.textContent = want;
      }
    });
  }

  function init() {
    apply();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
